import { ref } from 'vue';
import { RoadsideAssistanceService as roadsideAssistanceService } from '@/services/store/roadside-assistance.service';
import {
  AssistanceMatchPartyRequest,
  AssistanceMatchPartyResponse,
} from '@/interfaces/entities/roadside-assistance.interface';

export default function usePartyMatchState() {
  const partyMatchState = ref<AssistanceMatchPartyResponse | null>(null);

  async function setPartyMatchState(
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    emailAddress?: string,
    phoneNumber?: string,
    postalAddressDpid?: string
  ): Promise<boolean> {
    try {
      const matchPartyRequest: AssistanceMatchPartyRequest = {
        firstName: firstName,
        lastName: lastName,
        dateOfBirth: dateOfBirth,
        emailAddress: emailAddress,
      };
      if (postalAddressDpid) {
        matchPartyRequest.postalAddressDpid = postalAddressDpid;
      }
      if (phoneNumber) {
        matchPartyRequest.phoneNumber = phoneNumber;
      }

      const response = await roadsideAssistanceService.matchParty(matchPartyRequest);
      partyMatchState.value = response;
      return response !== null;
    } catch (e) {
      console.error('Failed to set PartyMatch state', e);
      return false;
    }
  }

  return { partyMatchState, setPartyMatchState };
}
